// extracted by mini-css-extract-plugin
export var divider = "_sd-0";
export var systemMessage = "_sd-1";
export var systemMessageWrapper = "_sd-2";